import { render, staticRenderFns } from "./ExceptionCollectionBulk.vue?vue&type=template&id=b9058700&scoped=true&"
import script from "./ExceptionCollectionBulk.vue?vue&type=script&lang=js&"
export * from "./ExceptionCollectionBulk.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionCollectionBulk.vue?vue&type=style&index=0&id=b9058700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9058700",
  null
  
)

export default component.exports